// ✅ Importaciones
import { ProfesionalProps } from '@/types'; // Tipado de las props del profesional

// 💡 Componente funcional que renderiza la información de un profesional
const Profesional: React.FC<ProfesionalProps> = ({
  selectedProfesiones = [], // Array de profesiones seleccionadas (por defecto vacío)
  formData1,               // Objeto con datos del profesional
  isEmpresa,               // Booleano que indica si el profesional es una empresa
}) => {
  // 🔍 Logs para depuración en consola

  return (
    <>
      <ul className="space-y-1 text-base leading-relaxed">

        {isEmpresa && (
          <>
            <li className="flex items-center">
              <span className="mr-2">•</span>
              <span><strong>Nombre Empresa:</strong> {formData1?.nombre_empresa}</span>
            </li>

            <li className="flex items-center">
              <span className="mr-2">•</span>
              <span><strong>CIF:</strong> {formData1?.cif}</span>
            </li>
          </>
        )}

        <li className="flex items-center">
          <span className="mr-2">•</span>
          <span><strong>Nombre:</strong> {formData1?.nombre || ''}</span>
        </li>

        <li className="flex items-center">
          <span className="mr-2">•</span>
          <span><strong>Apellidos:</strong> {formData1?.apellidos || ''}</span>
        </li>

        <li className="flex items-center">
          <span className="mr-2">•</span>
          <span><strong>Dni/Nie:</strong> {formData1?.dniNie || ''}</span>
        </li>

        <li className="flex items-center">
          <span className="mr-2">•</span>
          <span><strong>Dirección:</strong> {formData1?.calle || ''}</span>
        </li>

        <li className="flex items-center">
          <span className="mr-2">•</span>
          <span><strong>Localidad:</strong> {formData1?.locality || ''}</span>
        </li>

        <li className="flex items-center">
          <span className="mr-2">•</span>
          <span><strong>Provincia:</strong> {formData1?.province || ''}</span>
        </li>

        <li className="flex items-center">
          <span className="mr-2">•</span>
          <span><strong>Código Postal:</strong> {formData1?.postalCode || ''}</span>
        </li>

        <li className="flex items-center">
          <span className="mr-2">•</span>
          <span><strong>Teléfono:</strong> {formData1?.numero_telefono || ''}</span>
        </li>

        <li className="flex items-center">
          <span className="mr-2">•</span>
          <span>
            <strong>Profesión Escogida:</strong>{" "}
            {selectedProfesiones.length > 0
              ? selectedProfesiones
              : "No se ha seleccionado ninguna profesión."}
          </span>
        </li>

      </ul>
    </>
  );
};

// 🚀 Exportación del componente
export default Profesional;
